/** Complete create-draft body. Matches the Provider write schema defaults. */

export const DEFAULT_ADMISSION_PROFILE_PAYLOAD = {
  intended_treatment: 'AUTHORITATIVE_CANDIDATE',
  allowed_instrument_types: [],
  legal_regimes: [],
  control_profile: 'NONE',
  mixed_packages_permitted: false,
  primary_instrument_label: '',
  business_context: {},
  source_policy: {},
  party_policy: {},
  evidence_rules: { items: [] },
  question_rules: {
    always_confirmed_facts: [],
    required_confirmations: [],
  },
  certification_policy: {},
  attestation_version: 'UNSPECIFIED',
};
